<!-- Hero Section Begin -->
<div class="body">
    <app-hero></app-hero>
    <br><br>
    <app-whats-new></app-whats-new>
    <br><br>
    <app-featured></app-featured>
    <br><br>
    <app-explore></app-explore>
    <br><br><br>
    <!--    Start of signing up steps-->
    <app-how-to-sign-up></app-how-to-sign-up>
    <br><br><br>
</div>
    <!--    End of signing up steps-->
    <!--  New design -->
<!--    <div class="product spad">-->
<!--        <div class="container">-->
<!--            <div class="row">-->
<!--                <div class="col-lg-9">-->
<!--                    <div class="trending__product">-->
<!--                        <div class="row">-->
<!--                            <div class="col-lg-9 col-md-9 col-sm-9">-->
<!--                                <div class="section-title">-->
<!--                                    <h4>Trending Now</h4>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-lg-3 col-md-3 col-sm-3">-->
<!--                                <a routerLink="/games">-->
<!--                                    <button class="btn view-more-btn  btn-sm ">view more</button>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="row">-->
<!--                            <div class="container">-->
<!--                                <div class="row">-->
<!--                                    <div *ngIf="!gamesLoaded">-->
<!--                                        <div class="row ">-->
<!--                                            <div class="loader-tab">-->
<!--                                                <div class="loader"></div>-->
<!--                                            </div>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let game of games | limitTo: 5">-->

<!--                                        <a [routerLink]="['/game-detail', game.id]">-->
<!--                                            <div class="product-item">-->
<!--                                                <div class="product-item-pic set-bg"-->
<!--                                                     style="background-image: url('data:image/png;base64,{{game.image }}')">-->
<!--                                                    &lt;!&ndash;                        <div class="ep">18 / 18</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <div class="view"><i class="fa fa-eye"></i> {{ game.totalClicks }}&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </div>&ndash;&gt;-->
<!--                                                </div>-->
<!--                                                <div class="product__item__text">-->
<!--                                                    <ul>-->
<!--                                                        <li>{{game.genre}}</li>-->
<!--                                                    </ul>-->
<!--                                                    <h5><a [routerLink]="['/game-detail', game.id]">{{ game.name }}</a>-->
<!--                                                    </h5>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->
<!--                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">-->
<!--                    <div class="section-title">-->
<!--                        <h5>Leader Board</h5>-->
<!--                    </div>-->
<!--                    <div *ngIf="!usersLoaded">-->
<!--                        <div class="row ">-->
<!--                            <div class="loader-tab">-->
<!--                                <div class="loader"></div>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </div>-->
<!--                    <ul class="leaderboard-list" *ngFor="let userAccount of userAccounts | limitTo: 5; let i = index">-->
<!--                        <li class="leaderboard-item">-->
<!--                                <span>-->
<!--                                  &lt;!&ndash; Conditionally show image for 1st, 2nd, and 3rd positions &ndash;&gt;-->
<!--                                  <img *ngIf="i < 3" [src]="'assets/img/badges/medal-' + (i + 1) + '.png'" alt="Medal {{ i + 1 }}" class="medal-image">-->

<!--                                    &lt;!&ndash; Show text for 4th and 5th positions &ndash;&gt;-->
<!--                                  <span *ngIf="i >=  3" style="color: var(&#45;&#45;theme-red);">{{ i + 1 }}</span>-->
<!--                                </span>-->
<!--                            <span class="user-name">{{ userAccount.user.userName }}</span>-->
<!--                            <span class="user-points">{{ userAccount.points }} Points</span>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                    <div *ngIf="userAccounts.length > 5">-->
<!--                        <button class=" btn view-more-btn btn-sm" routerLink="/leaderboard">View More</button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--                <div class="col-lg-12">-->
<!--                    <div class="trending__product">-->
<!--                        <div class="row">-->
<!--                            <div class="col-lg-10 col-md-10 col-sm-10">-->
<!--                                <div class="section-title">-->
<!--                                    <h4>New For You</h4>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-lg-2 col-md-2 col-sm-2">-->
<!--                                <a (click)=" routeToPage('/games')">-->
<!--                                    <button class="btn  btn-sm view-more-btn">view more</button>-->
<!--                                </a>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                        <div class="row">-->
<!--                            <div class="container">-->
<!--                                <div class="row">-->
<!--                                    <div *ngIf="!gamesLoaded">-->
<!--                                        <div class="row ">-->
<!--                                            <div class="loader-tab">-->
<!--                                                <div class="loader"></div>-->
<!--                                            </div>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let game of games | limitTo: 5">-->
<!--                                        <div class="product-item">-->
<!--                                            <div class="product-item-pic set-bg"-->
<!--                                                 style="background-image: url('data:image/png;base64,{{game.image }}')">-->
<!--&lt;!&ndash;                                                <div class="view"><i class="fa fa-eye"></i> {{ game.totalClicks }}</div>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                            <div class="product__item__text">-->
<!--                                                <ul>-->
<!--                                                    <li>{{game.genre}}</li>-->
<!--                                                </ul>-->
<!--                                                <h5><a href="{{game.url}}">{{ game.name }}</a></h5>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--    &lt;!&ndash;  End of New design &ndash;&gt;-->


<!--</div>-->

